<template>
  <div class="orderInfo">
    <div
      class="fontSize16 fw-800"
      style="margin-left: 12px; margin-bottom: 10px"
    >
      {{ title }}
    </div>
    <el-form
      v-if="!isEmpty(infoMap)"
      :model="infoMap"
      label-width="230px"
      class="el-viewform"
      ref="form"
    >
      <el-form-item
        v-for="(item, index) in infoMap"
        :label="item.label"
        :key="index"
      >
        <div>
          <span v-if="item.type === 'time'" class="info-text">{{
            item.value ? dayjs(item.value).format('YYYY-MM-DD') : ''
          }}</span>
          <span v-else-if="item.type === 'boolean'" class="info-text">{{
            +item.value ? '是' : '否'
          }}</span>
          <span v-else-if="item.type === 'region'">{{
            formatRegion(item.value.split(','))
          }}</span>
          <!-- <span v-else-if="item.type === 'file'">
             <FilePreView  :id="item.value" />
          </span> -->
            <template v-else-if="item.type === 'file'">
            <el-popover
              v-if="item.value"
              title="下载提示"
              placement="top"
              trigger="hover"
            >
              <el-button
                slot="reference"
                type="text"
                class="info-file"
                @click="handleViewFile(item.value)"
                >{{ item.format }}
              </el-button>
              <el-button
                type="primary"
                @click="handleDownload(item.value)"
                :loading="downloadLoading"
                size="mini"
               round >点击下载 <i class="el-icon-download el-icon--right"></i> </el-button
              >
            </el-popover>
          </template>

          <span v-else class="info-text">{{ item.value }}</span>
        </div>
      </el-form-item>
    </el-form>
    <div v-else style="margin-left: 12px">无相关信息</div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { isEmpty } from 'lodash'
import { data } from '@/util/cityData'
import { download } from '@/shared/file'
import FilePreView from '@/components/FilePreview/FilePreview'
export default {
   components: {
    FilePreView,
  },
  props: {
    title: String,
    infoMap: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      downloadLoading: false,
      dayjs,
      isEmpty,
    }
  },
  methods: {
    handleViewFile(v) {
      window.open(`/zcjf/base/file/download/${v}`)
    },
    handleDownload(v) {
      this.downloadLoading = true
      download(v).then(() => {
        this.downloadLoading = false
      })
    },
    formatRegion(key) {
      let d = data,
        res = []
      while (Array.isArray(key) && key.length) {
        const cur = key.shift()
        const curData = d.find((item) => item.value === cur)
        if (curData) {
          d = curData.children
          res.push(curData.label)
        }
      }
      return res.join(' / ')
    },
  },
}
</script>

<style scoped lang="less">
.orderInfo {
  border: 1px solid #dbdbdb;
  border-radius: 10px;
  margin: 20px 0;
  padding: 10px;
  .info {
    &-file {
    }
  }
}
</style>
